import { datadogLogs } from '@datadog/browser-logs';
import { IconCheckCircleFilled } from '@iwoca/icons';
import { fetchGetPaymentMethod } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';
import { Select } from '@ui';
import { FormattedMessage, useIntl } from 'react-intl';

import styles from './BankDetailsActionDE.module.css';
import { useStateKey } from '../../../../../iwQueryClient/useStateKey';

export const VerifiedAccount = () => {
    const intl = useIntl();

    const stateKey = useStateKey();
    const { data: paymentMethods, isLoading: isPaymentMethodsLoading } =
        useQuery({
            queryKey: ['fetchGetPaymentMethod', stateKey],
            queryFn: () =>
                fetchGetPaymentMethod({
                    stateKey
                })
        });

    const fundingPaymentMethodWithIban = paymentMethods?.data.find(
        (paymentMethod) =>
            paymentMethod.roles.funding === 'enabled' &&
            paymentMethod.payment_method_type === 'bank_account' &&
            // @ts-expect-error as DE Schema differs to UK and LAPI types
            paymentMethod.bank_details?.iban
    );

    // @ts-expect-error as DE Schema differs to UK and LAPI types
    const fundingIban = fundingPaymentMethodWithIban?.bank_details?.iban;

    if (!isPaymentMethodsLoading && !fundingIban) {
        datadogLogs.logger.error(
            `Funding IBAN not found for customer ${stateKey}`
        );
    }

    return (
        <div
            className={styles.stepItemContainer}
            data-testid="DE-completed-bank-details"
        >
            <div className={styles.stepMessages}>
                <span className={styles.title}>
                    <FormattedMessage
                        id="_.funding_requirements.pending_bank_details_title"
                        defaultMessage="Your business bank details"
                    />
                </span>
                <span className={styles.caption}>
                    <FormattedMessage
                        id="_.funding_requirements.add_bank_details_caption"
                        defaultMessage="We’ll send the funds to this account."
                    />
                </span>
            </div>
            <div className={styles.buttonDropDownRow}>
                <Select
                    data-testid="account-number-select"
                    className={styles.accountNumberDropdown}
                    value={fundingIban}
                    disabled
                >
                    <option key={fundingIban} value={fundingIban}>
                        {intl.formatMessage(
                            {
                                id: '_.select_payment_method.verified_bank_account_selected_value',
                                defaultMessage: 'Account: {number}'
                            },
                            {
                                number: fundingIban
                            }
                        )}
                    </option>
                </Select>
                <div>
                    <IconCheckCircleFilled
                        height="24"
                        width="24"
                        fill="rgba(0, 77, 51, 1)"
                        xlinkTitle="checked"
                    />
                </div>
            </div>
        </div>
    );
};
